module.exports = __webpack_public_path__ + "media/images/item/kuchi_t-43fafd44978f080fbf03136cb9d1a017.gif";